var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.8662 9.56518L16.9208 8.19366C16.5683 7.94519 16.0811 8.19821 16.0811 8.62903V9.46788H6.74023C6.44605 9.46788 6.20752 9.70638 6.20752 10.0006C6.20752 10.2948 6.44605 10.5333 6.74023 10.5333H16.0811V11.3721C16.0811 11.8057 16.5708 12.054 16.9207 11.8074L18.8661 10.4359C19.1632 10.2266 19.1692 9.77925 18.8662 9.56518Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.321 13.2046L16.321 13.2046C15.9469 12.9883 15.4681 13.1159 15.2516 13.4902L15.2515 13.4902C14.0432 15.5792 11.7849 16.9808 9.20474 16.9808C5.35609 16.9808 2.22456 13.8493 2.22456 10.0006C2.22456 6.15199 5.35609 3.02045 9.20474 3.02045C11.7866 3.02045 14.0438 4.42332 15.2515 6.51099C15.468 6.8853 15.9469 7.01289 16.3209 6.79664L16.3209 6.79662C16.6951 6.58018 16.8229 6.10136 16.6066 5.72722L16.6065 5.7272C15.1244 3.16494 12.3557 1.45508 9.20474 1.45508C4.4817 1.45508 0.65918 5.27719 0.65918 10.0006C0.65918 14.7237 4.48129 18.5462 9.20474 18.5462C12.357 18.5462 15.125 16.8351 16.6066 14.274L16.6066 14.274C16.823 13.8998 16.6951 13.4211 16.321 13.2046Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/Logout.ee8a2321fffe2687ff3985b31efcae6a.svg";
export { ForwardRef as ReactComponent };